import { render, staticRenderFns } from "./flutterwavePay.vue?vue&type=template&id=7ca8b614&scoped=true"
import script from "./flutterwavePay.vue?vue&type=script&lang=js"
export * from "./flutterwavePay.vue?vue&type=script&lang=js"
import style0 from "./flutterwavePay.vue?vue&type=style&index=0&id=7ca8b614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca8b614",
  null
  
)

export default component.exports